import { Button, Spin } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

import ModalContainer from "../ModalContainer";

import styles from "./InformeUnificatModal.module.css";

const DESCRIPTION =
  "El document inclou el consolidat dels mòduls seleccionats. En confirmar, l'arxiu es descarregarà localment en el teu ordinador.";

export type InformeStatus = "idle" | "loading" | "success" | "error";

interface InformeUnificatModalProps {
  open: boolean;
  status: InformeStatus;
  onCancel: () => void;
  onDownload: () => void;
}

const STATUS_CONFIG: Record<Exclude<InformeStatus, "idle">, { icon: React.ReactNode; text: string }> = {
  loading: {
    icon: <Spin size="default" />,
    text: "Generant arxiu… Ho veuràs en les teves descàrregues en un moment.",
  },
  success: {
    icon: <CheckCircleOutlined className={styles.successIcon} />,
    text: "Informe descarregat correctament.",
  },
  error: {
    icon: <CloseCircleOutlined className={styles.errorIcon} />,
    text: "Error generant l'informe. Torna-ho a provar.",
  },
};

const InformeUnificatModal = ({
  open,
  status,
  onCancel,
  onDownload,
}: InformeUnificatModalProps) => {
  return (
    <ModalContainer
      open={open}
      centered
      onCancel={status === "loading" ? undefined : onCancel}
      closable={status !== "loading"}
      width={520}
      className={styles.modal}
      styles={{
        mask: { backgroundColor: "#B5BAC299" },
      }}
    >
      <h3 className={styles.title}>Descàrrega d'informe unificat</h3>

      {status === "idle" ? (
        <>
          <p className={styles.description}>{DESCRIPTION}</p>
          <footer className={styles.footer}>
            <Button onClick={onCancel} type="default">
              Cancel·lar
            </Button>
            <Button onClick={onDownload} type="primary">
              Descarregar
            </Button>
          </footer>
        </>
      ) : (
        <div className={styles.statusBlock}>
          {STATUS_CONFIG[status].icon}
          <p className={styles.statusText}>{STATUS_CONFIG[status].text}</p>
          {status !== "loading" && (
            <footer className={styles.footer}>
              <Button onClick={onCancel} type="primary">
                Tancar
              </Button>
            </footer>
          )}
        </div>
      )}
    </ModalContainer>
  );
};

export default InformeUnificatModal;
